<template>
    <v-container class="pa-5" fluid>
        <page-title>Rejestr gum na lakier dyspersyjny</page-title>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="rubbers"
                        :loading="rubbersLoading"
                        :mobile-breakpoint="0"
                        :items-per-page="5"
                    >
                        <template #item.customerName="{item}">
                            {{ item.customer.name }}
                        </template>
                        <template #item.jobName="{item}">
                            <v-tooltip
                                v-if="item.jobName.length > 15"
                                :open-delay="tooltipDelay"
                                top
                            >
                                <template #activator="{on}">
                                    <span v-on="on">{{ getShortStringOfJobName(item.jobName) }}</span>
                                </template>
                                {{ item.jobName }}
                            </v-tooltip>
                            <span v-else>{{ item.jobName }}</span>
                        </template>
                        <template #item.lastUsageDateTime="{item}">
                            {{ formatDate(item.lastUsageDateTime, false) }}
                        </template>
                        <template #item.additionalJobNumbers="{item}">
                            {{ getFirstJobNumber(item.additionalJobNumbers) }}

                            <v-tooltip
                                v-if="item.additionalJobNumbers.length > 1"
                                :open-delay="tooltipDelay"
                                bottom
                            >
                                <template #activator="{on}">
                                    <v-chip
                                        small
                                        class="ml-1"
                                        color="warning"
                                        v-on="on"
                                    >
                                        +{{ item.additionalJobNumbers.length - 1 }}
                                    </v-chip>
                                </template>
                                <div
                                    v-for="(jobNumber, index) in getWithoutFirstJobNumber(item.additionalJobNumbers)"
                                    :key="index"
                                >
                                    {{ jobNumber.name }}
                                </div>
                            </v-tooltip>
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import PageTitle from '@/components/common/PageTitle'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'ConfigurationsRubberRegistry',
    components: {
        PageTitle,
    },
    mixins: [
        dateFormatter,
        parse,
        tooltipDelay,
    ],
    data() {
        return {
            headers: [
                {
                    text: 'Lp.',
                    value: 'serialNumber',
                    sortable: false
                },
                {
                    text: 'Klient',
                    value: 'customerName',
                    sortable: false
                },
                {
                    text: 'Główny nr zlecenia',
                    value: 'mainJobNumber',
                    sortable: false
                },
                {
                    text: 'Nazwa zlecenia',
                    value: 'jobName',
                    sortable: false
                },
                {
                    text: 'Data ostatniego użycia',
                    value: 'lastUsageDateTime',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Ilość dni od ostatniego użycia',
                    value: 'daysFromLastUsage',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Pozostałe numery zleceń',
                    value: 'additionalJobNumbers',
                    align: 'center',
                    sortable: false
                },
            ]
        }
    },
    computed: {
        rubbers() {
            return this.$store.state.configurations.rubberRegistry.rubbers
        },
        rubbersLoading() {
            return this.$store.state.configurations.rubberRegistry.rubberLoading
        },
    },
    mounted() {
        this.getRubbers()
    },
    methods: {
        getRubbers() {
            this.$store.dispatch('configurations/getRubbers')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getFirstJobNumber(jobNumbers) {
            if (!jobNumbers.length) {
                return '-'
            }

            return jobNumbers[0].name
        },
        getWithoutFirstJobNumber(jobNumbers) {
            if (!jobNumbers.length) {
                return []
            }

            return jobNumbers.slice(1)
        },
        getShortStringOfJobName(jobName) {
            if (jobName.length > 15) {
                return jobName.substring(0, 15) + '...'
            }

            return jobName
        },
    },
}
</script>
